module.exports = "<div data-template> <span class=voc-live-time>{{FormattedDate}}</span> <span class=voc-live-author>{{Creator.Name}}</span> <p> {% if Link %} <a href={{Link}}>{{Content}}</a> {% else %} <a>{{Content}}</a> {% endif %} </p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/templates/widget.html
// module id = 5
// module chunks = 0